/*****************************************************/
/* 処　理：SMS003 現在残高・支払希望日 画面
/*
/* 概　要：定数定義
/*
/* 更新日：2025/01/08 HARAGU 00011_SMS機能等の導入支援
/*****************************************************/

// 処理名
export const INIT_NAME = '初期表示';
export const BTN_DETAIL_NAME = '詳細金額表示へ';
export const BTN_EXECUTE_NAME = '送信';
export const BTN_BACKMENU_NAME = 'メニューへ戻る';

// APIパス
export const API_INIT_PATH = '/SMS003/init';
export const API_EXECUTE_PATH = '/SMS003/execute';

// 入力可否日付(デフォルト：当月20日まで)
export const INPUT_LIMIT_DAY = 20;
